// extracted by mini-css-extract-plugin
module.exports = {"container":"IconWithText_container__3HSe1 text-body","iconContainer":"IconWithText_iconContainer__Xd30y"};